import { RefObject } from 'react';
import { usePhrase } from '@/hooks';
import { useTextOverflowEllipsis } from '@/hooks/helpers/useTextOverflowEllipsis';
import { Tooltip } from '../Tooltip/Tooltip';

interface LabelWithTooltipProps {
    label: string | number;
    labelRef: RefObject<HTMLLabelElement | null>;
}

export const LabelWithTooltip = ({ label, labelRef }: LabelWithTooltipProps) => {
    const { t } = usePhrase();

    const labelHasTextOverflow = useTextOverflowEllipsis(labelRef);
    const labelText = typeof label === 'string' ? label : t(label);

    return (
        <>
            {labelHasTextOverflow ? (
                <Tooltip title={labelText} followCursor>
                    <span>{labelText}</span>
                </Tooltip>
            ) : (
                <>{labelText}</>
            )}
        </>
    );
};
